"use strict";

import {find, findIn, findAll, setAttribute, removeClass, addClass} from "@elements/dom-utils"
import {onFind} from "@elements/init-modules-in-scope";
import {registerPermissionGrantedCallback} from "./elements-packages/cookie-permissions";


export function init () {
    registerPermissionGrantedCallback('externalVideo', function () {
        onFind('.js-external-video-area', function (mapElement) {
            let video = findIn('.js-external-video', mapElement);
            let videoSrc = video.dataset.src;
            setAttribute("src", videoSrc, video);
            let overlay = findIn('.js-accept-cookies-overlay', mapElement);
            addClass('is-hidden', overlay);
        });
    });
}
